export type RankName = 'topCat' | 'purrfect' | 'meowsome' | 'goodKitty' | 'pickOfTheLitter'

export function positionToRank(position: number): RankName {
  switch (true) {
    case position === 0:
      return 'pickOfTheLitter'
    case position <= 10:
      return 'topCat'
    case position <= 100:
      return 'purrfect'
    case position <= 500:
      return 'meowsome'
    case position <= 1000:
      return 'goodKitty'
    default:
      return 'pickOfTheLitter'
  }
}

export const rankToTitle: Record<RankName, string> = {
  topCat: 'Top cat',
  purrfect: 'Purrfect',
  meowsome: 'Meowsome',
  goodKitty: 'Good kitty',
  pickOfTheLitter: 'Pick of the litter',
}

export const rankToAssetName: Record<RankName, string> = {
  topCat: 'top-cat',
  purrfect: 'purrfect',
  meowsome: 'meowsome',
  goodKitty: 'good-kitty',
  pickOfTheLitter: 'pick-of-the-litter',
}

export function rankToBadgeUrl(rank: RankName): string {
  return `/assets/season-mew-badges/${rankToAssetName[rank]}.webp`
}

export function spotsToNextBadgeText(spotsToNext: number | null, unranked: boolean): string | null {
  switch (true) {
    case unranked:
      return 'Use the protocol to climb the ranks!'
    case spotsToNext === null:
      return "You're at the top!"
    default:
      return `${spotsToNext} spots till next badge`
  }
}

export function calculateSpotsToNextBadge(position: number): number | null {
  switch (true) {
    case position <= 10:
      return null
    case position <= 100:
      return position - 10
    case position <= 500:
      return position - 100
    case position <= 1000:
      return position - 500
    default:
      return position - 1000
  }
}
